// extracted by mini-css-extract-plugin
export var alertIcon = "_v6-0";